document.addEventListener('DOMContentLoaded', function () {
  var swiperThumbs = new Swiper('.js_swiper_thumbs', {
    slidesPerView: 4,
    spaceBetween: 20,
  });

  var swiperMain = new Swiper('.js_swiper_main', {
    autoHeight: true,
    speed: 500,
    spaceBetween: 40,
    thumbs: {
      swiper: swiperThumbs,
    },
    navigation: {
      nextEl: '.bl_swiperThumbs_arrowNext',
      prevEl: '.bl_swiperThumbs_arrowPrev',
    },
  });

  // 画像クリックでモーダルを表示
  const images = document.querySelectorAll('.js-gallery-image');
  const modal = document.getElementById('imageModal');
  const modalImage = document.getElementById('modalImage');
  const modalClose = document.querySelector('.modal-close');

  images.forEach(image => {
    image.addEventListener('click', function() {
      modal.style.display = 'block';
      modalImage.src = this.src;
      document.body.style.overflow = 'hidden'; // body のスクロールを無効化
    });
  });

  // モーダルを閉じる
  modalClose.addEventListener('click', function() {
    modal.style.display = 'none';
    document.body.style.overflow = ''; // body のスクロールを元に戻す
  });

  // モーダルの外側をクリックで閉じる
  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = 'none';
      document.body.style.overflow = ''; // body のスクロールを元に戻す
    }
  });
});


